// extracted by mini-css-extract-plugin
module.exports = {"root":"_e327fe","logo":"_d6409d","content":"_0d9b6e","title":"_8edb0c"};